import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-24 bg-[#F9F6F1]">
      <div className="max-w-4xl mx-auto px-[5%]">
        <div className="flex items-center justify-center gap-2 mb-8">
          <div className="w-2 h-2 rounded-full bg-orange-500"></div>
          <span className="text-xs font-semibold tracking-wider text-gray-600 uppercase">{t('about.title')}</span>
        </div>
        
        <h2 className="text-5xl font-bold text-gray-900 text-center mb-12" style={{ fontFamily: 'Inter, sans-serif' }}>
          {t('about.subtitle')}
        </h2>
        
        <div className="space-y-6 text-lg text-gray-700 leading-relaxed text-justify mb-16">
          <p>
            {t('about.description1')}
          </p>
          <p>
            {t('about.description2')}
          </p>
        </div>
        
        <div className="grid grid-cols-2 gap-x-16 gap-y-12">
          <div className="text-center">
            <div className="text-7xl font-bold text-gray-900 mb-2">50+</div>
            <div className="text-base text-gray-500 font-light">{t('about.stat1')}</div>
          </div>
          <div className="text-center">
            <div className="text-7xl font-bold text-gray-900 mb-2">3</div>
            <div className="text-base text-gray-500 font-light">{t('about.stat2')}</div>
          </div>
          <div className="text-center">
            <div className="text-7xl font-bold text-gray-900 mb-2">100%</div>
            <div className="text-base text-gray-500 font-light">{t('about.stat3')}</div>
          </div>
          <div className="text-center">
            <div className="text-7xl font-bold text-gray-900 mb-2">24/7</div>
            <div className="text-base text-gray-500 font-light">{t('about.stat4')}</div>
          </div>
        </div>
      </div>
    </section>
  );
}
